// @flow
import * as React from 'react';
import { Select } from '@locus-taxy/neo-ui';

import { useTeams } from 'platform/settings/hooks/useTeam';

type Props = {
    label: string,
    value: string,
    onChange: (value: string) => void
};

export const TeamInput = ({ value, label, onChange }: Props): React.Node => {
    const teams = useTeams();

    const options = React.useMemo(() => {
        let optionsData = [];
        if (teams.data) {
            optionsData = teams.data.toArray().map(({ teamId, name }) => ({
                label: name,
                value: teamId
            }));
        }
        optionsData.unshift({
            label: 'All Teams',
            value: 'all_teams'
        });
        return optionsData;
    }, [teams.data]);

    return (
        <Select
            value={value}
            label={label}
            placeholder={label}
            onChange={option => onChange(option?.value ? option.value : '')}
            options={options}
            disabled={false}
            fullWidth
        />
    );
};

export default TeamInput;
